export default __webpack_public_path__ + "static/media/langSikt.42c0eac8.svg";